import { Box, Skeleton, Stack, Typography, useTheme } from '@mui/material';
import CopyButton from '../../commonUI/CopyButton';

type DebugInfoSlotProps = {
  label: string;
  value: string;
  isLoading?: boolean;
  showCopyButton?: boolean;
};

/**
 * DebugInfoSlot - A reusable component for displaying labeled information in debug sections
 */
export const DebugInfoSlot = ({
  label,
  value = '',
  isLoading = true,
  showCopyButton = true,
}: DebugInfoSlotProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Stack direction='row' spacing={1} alignItems={'center'}>
        <Typography
          variant='body2'
          sx={{
            fontWeight: 'bold',
            color: theme.vars.palette.text.primary,
          }}
        >
          {`${label}:`}{' '}
        </Typography>
        <Typography
          variant='body2'
          sx={{ color: theme.vars.palette.text.secondary }}
        >
          {isLoading ? <Skeleton width={300} height={24} /> : value}
        </Typography>
        {!isLoading && showCopyButton && value && (
          <CopyButton textToCopy={value} />
        )}
      </Stack>
    </Box>
  );
};
